import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faCheck} from '@fortawesome/free-solid-svg-icons';
import {WizardStep} from '../wizard-step.model';

@Component({
  selector: 'app-wizard-step-shell',
  standalone: true,
  imports: [TranslatePipe, FaIconComponent],
  templateUrl: './wizard-step-shell.component.html',
  styleUrl: './wizard-step-shell.component.scss',
})
export class WizardStepShellComponent {
  @Input() title: string;
  @Input() steps: WizardStep[] = [];
  @Input() currentStepIndex = 0;
  @Input() maxReachedIndex = 0;
  @Input() isFirstStep = false;
  @Input() isLastStep = false;
  @Input() nextDisabled = false;

  @Output() backClicked = new EventEmitter<void>();
  @Output() nextClicked = new EventEmitter<void>();
  @Output() cancelClicked = new EventEmitter<void>();
  @Output() stepSelected = new EventEmitter<number>();

  protected readonly faCheck = faCheck;

  isStepCompleted(index: number): boolean {
    return index < this.maxReachedIndex;
  }

  isStepAccessible(index: number): boolean {
    return index <= this.maxReachedIndex;
  }

  selectStep(index: number): void {
    if (index !== this.currentStepIndex && this.isStepAccessible(index)) {
      this.stepSelected.emit(index);
    }
  }
}
